#import "./fragments/tagFragment.graphql"

# TODO Review and clear up use of these queries - many of them are unused as tags editor has its own queries
query getTags {
  tags: searchTags(tagTypes: [SKILL, SPECIALIST]) {
    id
    type
    label: displayValue
    value: id
  }
}

query getTagsForEntity($entityId: ID!, $tagTypes: [TagType]) {
  tags: getTagsForEntityV2(entityId: $entityId, tagTypes: $tagTypes) {
    ...TagFragment
  }
  tagTypesMetadata: getTagTypesMetadata(tagTypes: $tagTypes) {
    id
    name
    allowMultipleOnEntity
  }
}

query searchTags(
  $tagTypes: [TagType]
  $includeInactiveTags: Boolean = false
  $searchTerm: String = ""
  $tagIds: [ID] = []
) {
  tags: searchTags(
    tagTypes: $tagTypes
    includeInactiveTags: $includeInactiveTags
    searchTerm: $searchTerm
    tagIds: $tagIds
  ) {
    ...TagFragment
    appliedCount
  }
}

query pagedSearchTags(
  $input: PagedSearchTagsInput
  $showAppliedCount: Boolean = false
  $showTagOwners: Boolean = false
  $includeChildTags: Boolean = false
) {
  results: pagedSearchTags(input: $input) {
    tags {
      ...TagFragmentWithAppliedCount
      childTags @include(if: $includeChildTags) {
        tags {
          ...TagFragmentWithAppliedCount
          childTags @include(if: $includeChildTags) {
            tags {
              ...TagFragmentWithAppliedCount
              childTags @include(if: $includeChildTags) {
                tags {
                  id
                  type
                  isActive
                }
                hasMore
                total
              }
            }
            hasMore
            total
          }
        }
        hasMore
        total
      }
    }
    totalCount
  }
}

query getChildTags($tagId: ID!) {
  childTags: pagedSearchTags(input: { filter: { tagIds: [$tagId] } }) {
    tags {
      id
      childTags {
        tags {
          ...TagFragment
          appliedEntities(input: {}) {
            appliedEntities {
              relationshipType
              group {
                id
                name
                kind
                type
                hierarchy
                hierarchyIds
                parentIds
                attributes {
                  id
                  attributeType
                  subtype
                  label
                  value
                }
              }
            }
          }
        }
        total
      }
    }
  }
}

query searchAppliedTags(
  $entityIds: [ID]
  $tagIds: [ID]
  $tagTypes: [String]
  $appliedToTypes: [String]
  $modifiedAfter: DateTime
  $includeRemoved: Boolean
  $size: Int
  $offset: Int = 0
  $includeIndirectRelationships: Boolean = true
  $entityTypes: [EntityType]
  $childrenDepth: Int = 1
) {
  results: searchAppliedTags(
    entityIds: $entityIds
    tagIds: $tagIds
    tagTypes: $tagTypes
    appliedToTypes: $appliedToTypes
    modifiedAfter: $modifiedAfter
    includeRemoved: $includeRemoved
    size: $size
    offset: $offset
  ) {
    entityTags {
      id
      tagId
      type
      entityId
      entityTagAttributes
      tag {
        ...TagFragment
        appliedEntities(
          input: {
            includeIndirectRelationships: $includeIndirectRelationships
            entityTypes: $entityTypes
            childrenDepth: $childrenDepth
          }
        ) {
          appliedEntities {
            relationshipType
            group {
              id
              name
              type
            }
          }
        }
        childTags {
          total
        }
      }
    }
    totalCount
  }
}

query getEntityTagsByTagIds($tagIds: [ID!]) {
  tags: getEntityTagsByTagIds(tagIds: $tagIds) {
    ...EntityTagFragment
  }
}

# Using pagedSearchTags instead of searchTags to ensure tagAttributesMetaData.people is populated
# The searchTags resolver doesn't pass context to the database layer, which prevents
# the tagAttributesMetaData resolver from accessing the data loaders needed for the people array
query getTagDetails(
  $tagId: ID
  $showTagOwners: Boolean = false
  $showAppliedCount: Boolean = false
) {
  results: pagedSearchTags(
    input: { filter: { tagIds: [$tagId], includeInactiveTags: true } }
  ) {
    tags {
      ...TagFragmentWithAppliedCount
      properties {
        ...TagPropertyFragment
      }
    }
    totalCount
  }
}

query getEntitiesByTagId($tagId: ID) {
  entities: getEntityTagsByTagIds(tagIds: [$tagId]) {
    ...EntityTagFragment
  }
}

mutation removeAssociation($input: RemoveAssociationInput!) {
  removeAssociation(input: $input) {
    id
    tagId
    displayValue
  }
}

mutation updateTagValue($input: UpdateTagInput!) {
  tag: updateTag(input: $input) {
    ...TagFragment
  }
}

query availableTags($tagTypes: [TagType]) {
  tags: searchTags(tagTypes: $tagTypes) {
    ...TagFragment
  }
}

query getEntityTagCountsByType(
  $entityIds: [ID]!
  $tagTypes: [String]
  $includeRemovedTags: Boolean = false
) {
  result: getEntityTagCountsByType(
    entityIds: $entityIds
    tagTypes: $tagTypes
    includeRemovedTags: $includeRemovedTags
  ) {
    counts {
      entityId
      tagType
      count
    }
  }
}
